export default {
  state: () => ({
    ussid: null,
    token: null,
    auth: false,
    user: null,
    cashback: null,
    cashbackSettings: null,
    isTerminal: false,
    favoritesCount: null,
  }),
  mutations: {
    UPDATE_USS_ID(state, ussid) {
      state.ussid = ussid
    },
    UPDATE_CASHBACK(state, value) {
      state.cashback = value
    },
    UPDATE_CASHBACK_SETTINGS(state, value) {
      state.cashbackSettings = value?.fastCashback
    },
    UPDATE_AUTH(state, value) {
      state.auth = value
    },
    UPDATE_TOKEN(state, token) {
      state.token = token
    },
    UPDATE_USER(state, user) {
      state.user = { ...state.user, ...user }
    },
    UPDATE_USER_FIELD(state, { key, value }) {
      if (key && key in state.user) {
        state.user[key] = value
      }
    },
    UPDATE_USER_FIELDS(state, data) {
      state.user = { ...state.user, ...data }
    },
    UPDATE_FAVORITES_COUNT(state, value) {
      state.favoritesCount = value
    },
    REMOVE_TOKEN(state) {
      state.auth = false
      state.token = null
      state.user = null
      state.cashback = null
      state.ussid = null
    },
  },
  actions: {
    updateUSSID({ commit }, value) {
      commit('UPDATE_USS_ID', value)
    },
    updateCashback({ commit }, value) {
      commit('UPDATE_CASHBACK', value)
    },
    updateCashbackSettings({ commit }, value) {
      commit('UPDATE_CASHBACK_SETTINGS', value)
    },
    updateUser({ commit }, value) {
      commit('UPDATE_USER', value)
    },
    updateUserField({ commit }, value) {
      commit('UPDATE_USER_FIELD', value)
    },
    updateUserFields({ commit }, value) {
      commit('UPDATE_USER_FIELDS', value)
    },
    removeToken({ commit }) {
      commit('REMOVE_TOKEN')
    },
    updateToken({ commit }, value) {
      commit('UPDATE_TOKEN', value)
    },
    updateAuth({ commit }, value) {
      commit('UPDATE_AUTH', value)
    },
    updateFavoritesCount({ commit }, value) {
      commit('UPDATE_FAVORITES_COUNT', value)
    },
  },
  getters: {
    getCashback: (s) => s.cashback,
    getCashbackSettings: (s) => s.cashbackSettings,
    getUserBalanceBK: (s) => s.user?.bkBalance ?? null,
    getUserBalance: (s) => s.user?.balance ?? null,
    getUserBonusBalance: (s) => s.user?.bonusBalance ?? null,
    getUserBonusBalanceOn: (s) => s.user?.bonusBalanceOn ?? null,
    getUserCurrency: (s) => s.user?.currency ?? null,
    getUserCurrencyCode: (s) => s.user?.currency.code ?? null,
    getUserRegion: (s) => s.user?.region ?? null,
    getToken: (s) => s.token,
    getUserVerification: (s) => s.user?.docsVerificationId === 2,
    getUserVerificationStatus: (s) => s.user?.docsVerificationId ?? null,
    getUser: (s) => s.user,
    getUserLanguage: (s) => (s?.user?.language ? s?.user?.language.toLowerCase() : null),
    firstAuth: (s) => !!!s.user?.lastLogin,
    profileIsFilled: (s) => {
      if (!s.user) {
        return false
      }
      return s.user.profileIsFilled
    },
    userNeedVerification: (s) => {
      if (!s.user) {
        return false
      }
      return s.user.needVerification
    },
    userAccessToWithdraw: (s) => {
      if (!s.user) {
        return {
          access: false,
          message: '',
          errors: [],
        }
      }
      return {
        access: s.user.withdrawAccess,
        message: s.user.withdrawAccessStr,
        errors: s.user.withdrawAccessErrors,
      }
    },
    phoneApproved: (s) => {
      if (!s.user) {
        return false
      }
      return s.user.phoneApproved
    },
    emailApproved: (s) => {
      if (!s.user) {
        return false
      }
      return s.user.emailApproved
    },
    getAuth: (s) => !!s.user,
    getCashbackPercent: (s) => s.cashbackSettings?.percent ?? '1',
    profileIsApproved: (s) =>
      process.env.PLATFORM === 'olymp' ? s.user?.profileIsApproved : s.user?.bkProfileIsApproved,
    profileIsApprovedSum: (s) =>
      process.env.PLATFORM === 'olymp' ? s.user?.profileIsApprovedSum : s.user?.bkProfileIsApproved,
    personalDataIsFilled: (s) => s.user?.personalDataIsFilled,
    thresholdAmount: (s) => s.user?.threshold?.amount ?? null,
    favoritesCount: (s) => s.favoritesCount,
    getIdentLevel: (s) => {
      const requiredSteps = []
      if (!s.user.phoneApproved) {
        requiredSteps.push(1)
      }
      if (!s.user.emailApproved) {
        requiredSteps.push(2)
      }
      if (!s.user.documentNum || !s.user.securityQuestionAnswer || !s.user.personalDataIsFilled) {
        requiredSteps.push(3)
      }
      return requiredSteps
    },
  },
}
